import { ComputedRef } from 'vue';
import { Stoppable } from '@vueuse/core';

export type ResendTimeout = { ready: ComputedRef<boolean> } & Stoppable;
export const SETTINGS_RESEND_INTERVAL = 60 * 1000;
export const REGISTRATION_RESEND_EMAIL_INTERVAL = 10 * 1000;
export const PASSWORD_RESET_RESEND_INTERVAL = 60 * 1000;
